import * as React from 'react';
import { FC } from 'react';

type PropsType = {
  counter: number,
}

const MenuItemCounter: FC<PropsType> = ({ counter }) => {
  if (!counter) {
    return null;
  }

  return (
    <span className="badge badge-pill badge-success ml-4p">
      {counter}
    </span>
  );
};

export { MenuItemCounter };
